import {idListIncludes} from '../../../components/optimizely/gdi/utils/gdi-id-list'

export const ROOT_CATEGORY_ID = 'root'

export const PLP_ADJACENT_AREA = {
    wrapperTypename: 'GDIPLPPageProductListAdjacentBlock',
    contentField: 'GDIPLPPageProductListAdjacentBlockContent'
}

export const PLP_GRID_INTERRUPTORS_AREA = {
    wrapperTypename: 'GDIPLPPageGridInterruptorsBlock',
    contentField: 'GDIPLPPageGridInterruptorsBlockContent'
}

export const selectMostSpecificPLPWrappers = (exactWrappers, inheritedWrappers, rootWrappers) => {
    if (exactWrappers.length > 0) return exactWrappers
    if (inheritedWrappers.length > 0) return inheritedWrappers
    return rootWrappers
}

/**
 * `exact` when a CategoryId matches the page, `inherited` when ApplyToSubcategories
 * covers a parent of it, `root` for the global fallback, otherwise `none`.
 */
export const classifyPLPCategoryMatch = (
    block,
    {categoryIds = [], parentCategoryTree = []} = {}
) => {
    const blockCategoryId = block?.CategoryId
    if (!blockCategoryId) return 'none'
    if (categoryIds.some((id) => idListIncludes(blockCategoryId, id))) return 'exact'
    if (block.ApplyToSubcategories) {
        const inherited = parentCategoryTree.some((c) => idListIncludes(blockCategoryId, c?.id))
        if (inherited) return 'inherited'
    }
    if (idListIncludes(blockCategoryId, ROOT_CATEGORY_ID)) return 'root'
    return 'none'
}

/** The most specific tier of wrappers targeting the page: exact > inherited > root. */
export const selectWrappersForCategory = (
    areaItems,
    {wrapperTypename, categoryIds = [], parentCategoryTree = []} = {}
) => {
    if (!Array.isArray(areaItems)) return []

    const exactWrappers = []
    const inheritedWrappers = []
    const rootWrappers = []

    areaItems.forEach((wrapper) => {
        const expanded = wrapper?.ContentLink?.Expanded
        if (!wrapperTypename || expanded?.__typename !== wrapperTypename) return
        const match = classifyPLPCategoryMatch(expanded, {categoryIds, parentCategoryTree})
        if (match === 'exact') exactWrappers.push(expanded)
        else if (match === 'inherited') inheritedWrappers.push(expanded)
        else if (match === 'root') rootWrappers.push(expanded)
    })

    return selectMostSpecificPLPWrappers(exactWrappers, inheritedWrappers, rootWrappers)
}

/** Unwrapped children of the matching wrappers, in authored order. */
export const extractBlocksForCategory = (areaItems, {contentField, ...matchContext} = {}) => {
    const wrappersToUse = selectWrappersForCategory(areaItems, matchContext)

    const blocks = []
    wrappersToUse.forEach((expanded) => {
        const children = expanded[contentField] || []
        children.forEach((child) => {
            const childExpanded = child?.ContentLink?.Expanded
            if (childExpanded) blocks.push(childExpanded)
        })
    })
    return blocks
}
